module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/apelv1-ef1db2ba2dc038cfc515404f9a453c63.jpg";